import { useCallback, useEffect, useMemo } from 'react';
import useSWRInfinite from 'swr/infinite';
import { fetchWithTokenAndRegion } from '@adsk/acs-sc-web-platform-api';
import { ALLOY_KEY_PREFIX, baseParser, setDataInStorage } from '../commonCache';
const alloyPrefix = str => str ? "".concat(ALLOY_KEY_PREFIX).concat(str) : str;
const removeSWRPart = key => {
  return key.replace('$inf$', '');
};
const defaultGetNextKey = data => (data === null || data === void 0 ? void 0 : data.pagination.nextUrl) || '';
const loadDataFromSessionStorage = (url, getNextKey) => {
  const res = [];
  let currentUrl = url;
  while (currentUrl) {
    const data = baseParser(sessionStorage.getItem(alloyPrefix(currentUrl)));
    if (data) {
      res.push(data);
    }
    currentUrl = data && getNextKey(data);
  }
  return res.length === 0 ? undefined : res;
};
const saveInStorage = (data, key, getNextKey) => {
  const storeKey = data.length - 1 === 0 ? removeSWRPart(key) : getNextKey(data[data.length - 2]);
  setDataInStorage(data[data.length - 1], storeKey);
};
const clearAllDataFromSessionStorage = (url, getNextKey) => {
  const keysToRemove = [];
  let curKey = url;
  while (curKey !== '') {
    if (curKey) {
      keysToRemove.push(alloyPrefix(curKey));
    }
    curKey = getNextKey(JSON.parse(sessionStorage.getItem(alloyPrefix(curKey))));
  }
  keysToRemove.forEach(key => sessionStorage.removeItem(key));
};
export const useGetAllPaginatedData = _ref => {
  let {
    url,
    fetcher = fetchWithTokenAndRegion,
    getNextKey = defaultGetNextKey
  } = _ref;
  const fallbackData = useMemo(() => loadDataFromSessionStorage(url, getNextKey), [url, getNextKey]);
  const {
    data,
    error,
    mutate,
    setSize,
    isValidating
  } = useSWRInfinite((pageIndex, previousPageData) => pageIndex === 0 ? url : getNextKey(previousPageData), fetcher, {
    fallbackData,
    onSuccess: (newData, key) => saveInStorage(newData, key, getNextKey),
    revalidateOnMount: true,
    revalidateOnFocus: false,
    shouldRetryOnError: false,
    revalidateFirstPage: false
  });
  useEffect(() => {
    if (data && !!getNextKey(data[data.length - 1])) {
      setSize(data.length + 1);
    }
  }, [data, getNextKey, setSize]);
  const hasMoreData = useMemo(() => !!url && !(data && data.length && !getNextKey(data[data.length - 1])), [url, data, getNextKey]);
  const clearSessionStorage = useCallback(() => {
    clearAllDataFromSessionStorage(url, getNextKey);
  }, [getNextKey, url]);
  const loading = isValidating || !error && hasMoreData;
  const retry = useCallback(() => mutate(), [mutate]);
  return {
    loading,
    retry,
    clearSessionStorage,
    data: data === undefined ? [] : data,
    error
  };
};
//# sourceMappingURL=useGetAllPaginatedData.js.map